let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jJLAh")).then(() => parcelRequire('dW87a'));